<template>
  <div class="section">
    <h1 class="ui center aligned header">
      Sale summary
    </h1>
    <div class="ui hidden divider"></div>
    <div class="ui hidden divider"></div>
    <div class="ui hidden divider"></div>
    <div class="ui bottom aligned very relaxed center aligned stackable equal width grid container">
      <div class="column">
        <img class="ui fluid image" src="../assets/info/iuor.png">
        <div class="ui hidden divider"></div>
        <p>Intended use of revenue</p>
      </div>
      <div class="column">
        <img class="ui fluid image" src="../assets/info/allocation.png">
        <div class="ui hidden divider"></div>
        <p>Token distribution</p>
      </div>
      <div class="column">
        <code>
          1 ether = 100 ANT
          <small>first 2 weeks</small>
        </code>
        <div class="ui hidden divider"></div>
        <code>
          1 ether = 66 ANT
          <small>last 2 weeks</small>
        </code>
        <div class="ui hidden divider"></div>
        <code>
          Hidden cap
          <small>Will be revealed during the sale or prior to being reached</small>
        </code>
        <div class="ui hidden divider"></div>
        <p>Token price and duration</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'saleSummary',
}
</script>

<style scoped>
code {
  font-family: 'Maison Neue Mono';
  display: block;
  font-size: 1.5rem;
}
small {
  margin-top: 0.5rem;
  display: block;
  font-size: 0.75rem;
}
.section {
  background: #f4f4f4;
}
</style>



// WEBPACK FOOTER //
// SaleSummary.vue?0493c573